import type { SOCSampleWithDocuments } from '../../../types/apiModels'
import { apiClient } from '../../ruutsApi/client'
import endpoints from '../../ruutsApi/endpoints'
import { unwrapVoid } from '../../ruutsApi/normalize'

export const updateSOCSample = async ({
  socSample,
}: {
  socSample: Partial<SOCSampleWithDocuments> & { id: string }
}): Promise<void> => {
  const response = await apiClient.put(endpoints.monitoringSOCSamples, socSample)
  return unwrapVoid(response)
}
